import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import ReorderIcon from '@mui/icons-material/Reorder'
import { pick } from 'lodash'
import { sortableContainer, sortableElement } from 'react-sortable-hoc'
import { useDispatch } from 'react-redux'

import { setLoading, showSnackbar } from '../../actions/pageActions'
import { TESTS_PATH } from '../../constants/endpointsConstants'
import { client } from '../../utils/client'
import { arrayMove } from '../../utils/typeResults.js'

const styles = {
  buttonGroup: {
    margin: '0 auto',
  },
  button: {
    margin: '10px',
  },
  listItem: {
    zIndex: 2000,
  },
}

const SortableContainer = sortableContainer(({ children }) => (
  <List>{children}</List>
))

const SortableItem = sortableElement(({ item }) => (
  <ListItem sx={styles.listItem}>
    <ListItemIcon>
      <ReorderIcon />
    </ListItemIcon>
    <ListItemText primary={item.name} />
  </ListItem>
))

const SortTypeResultsModal = ({ open, typeResults, testId, onClose }) => {
  const dispatch = useDispatch()
  const [typeResultsList, setTypeResultsList] = useState(typeResults)

  const onSortEnd = ({ oldIndex, newIndex }) =>
    setTypeResultsList(arrayMove(typeResultsList, oldIndex, newIndex))

  const handleSaveOrder = async () => {
    dispatch(setLoading(true))
    try {
      const formattedTypeResults = typeResultsList.map(typeResult =>
        pick(typeResult, 'id', 'name')
      )
      const {
        data: { message },
      } = await client.put(`${TESTS_PATH}/${testId}/updateTypeResultsOrder`, {
        typeResults: formattedTypeResults,
      })
      dispatch(showSnackbar(message, 'success'))
      onClose(typeResultsList)
    } catch (error) {
      dispatch(showSnackbar(error?.response?.data?.message))
    }
    dispatch(setLoading(false))
  }

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
    >
      <DialogTitle sx={{ textAlign: 'center' }} variant="h6" component="h2">
        Ordenar Tipos De Resultados
      </DialogTitle>
      <DialogContent sx={{ height: '400px', overflowY: 'auto' }}>
        <SortableContainer onSortEnd={onSortEnd}>
          {typeResultsList.map((item, index) => (
            <SortableItem key={`${item.id}`} index={index} item={item} />
          ))}
        </SortableContainer>
      </DialogContent>
      <DialogActions sx={styles.buttonGroup}>
        <Button
          sx={styles.button}
          variant="outlined"
          color="primary"
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          sx={styles.button}
          variant="contained"
          color="primary"
          onClick={handleSaveOrder}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SortTypeResultsModal.propTypes = {
  open: PropTypes.bool,
  typeResults: PropTypes.instanceOf(Array),
  testId: PropTypes.number.isRequired,
  onClose: PropTypes.func,
}

SortTypeResultsModal.defaultProps = {
  open: false,
  typeResults: [],
  onClose: () => {},
}

export default SortTypeResultsModal
